export default __webpack_public_path__ + "assets/images/apple-touch-icon_26XdW.png";